import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RbacGuard } from './guards/rbac.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage),
    canActivate: [MsalGuard, RbacGuard], //azure ad guard
    data: {
      roles: ['forecast-lab:user', 'cockpit:admin'], // Specify required roles
    },
  },
  {
    path: 'future-order',
    loadComponent: () =>
      import('./pages/future-order-tool/future-order-tool.component').then((m) => m.FutureOrderToolComponent),
    canActivate: [MsalGuard, RbacGuard], //azure ad guard
    data: {
      roles: [], // Specify required roles
    },
  },
  {
    path: 'material-mapping',
    loadComponent: () =>
      import('./pages/material-mapping-home/material-mapping-home.page').then((m) => m.MaterialMappingHomePage),
    canActivate: [MsalGuard, RbacGuard], //azure ad guard
    data: {
      roles: ['forecast-lab:user', 'cockpit:admin'], // Specify required roles
    },
  },
  {
    path: 'innovation-prediction',
    loadComponent: () =>
      import('./pages/innovation-mapping-home/innovation-mapping-home.component').then(
        (m) => m.InnovationMappingHomeComponent,
      ),
    canActivate: [MsalGuard, RbacGuard], //azure ad guard
    data: {
      roles: ['forecast-lab:user', 'cockpit:admin'], // Specify required roles
    },
  },
  {
    path: 'raise-access-request',
    loadComponent: () =>
      import('./pages/raise-access-request/raise-access-request.page').then((m) => m.RaiseAccessRequestPage),
    canActivate: [MsalGuard, RbacGuard],
    data: {
      roles: [], // Specify required roles
    },
  },
];
